import styled, { keyframes } from "styled-components";

// Shimmer sweep animation — moves a light band across the blurred compressed image
const shimmer = keyframes`
	0%   { background-position: -1200px 0; }
	100% { background-position:  1200px 0; }
`;

const LazyImageWrapper = styled.div`
	position: relative;

	/* ── Dark fallback: prevents any white flash while images are still fetching ── */
	background-color: #0d0d2b;
	background-size: 100% 100%;
	background-repeat: no-repeat;

	/* Show the compressed (small/blurred) image as a placeholder while the full
	   image loads. Once fully loaded we clear it so only the sharp <img> shows. */
	background-image: ${(props) =>
		!props.imageLoaded && props.compressedImage ? `url(${props.compressedImage})` : "none"};

	/* ─────────────────────────────────────────────────────────────────────────────
	   Shimmer + blur overlay
	   ─────────────────────────────────────────────────────────────────────────── */
	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
		pointer-events: none;

		/* Fade out the shimmer the moment the full image is loaded */
		opacity: ${(props) => (props.imageLoaded ? "0" : "1")};
		transition: opacity 0.6s ease;

		/* Moving light band over the blurred compressed image */
		background: linear-gradient(
			90deg,
			transparent 0%,
			rgba(255, 255, 255, 0.05) 25%,
			rgba(255, 255, 255, 0.11) 50%,
			rgba(255, 255, 255, 0.05) 75%,
			transparent 100%
		);
		background-size: 1200px 100%;
		animation: ${shimmer} 2.5s infinite linear;

		/* Soften the compressed image so the shimmer stands out cleanly */
		backdrop-filter: ${(props) => (props.imageLoaded ? "none" : "blur(8px)")};
	}

	/* ─────────────────────────────────────────────────────────────────────────────
	   Full-resolution image
	   ─────────────────────────────────────────────────────────────────────────── */
	.image {
		width: 100%;
		height: 100%;
		object-fit: fill;

		/* Sit above the shimmer overlay so it covers cleanly once loaded */
		position: relative;
		z-index: 2;

		/* Invisible while loading; smooth fade-in once loaded */
		opacity: ${(props) => (props.imageLoaded ? "1" : "0")};
		transition: opacity 0.6s ease;
	}
`;

export default LazyImageWrapper;
